import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageHeader, Spinner, Card, EmptyState } from "@/components/dash";
import StatusBadge from "@/components/StatusBadge";
import CoinIcon from "@/components/CoinIcon";
import { Button } from "@/components/ui/button";
import api, { apiErr } from "@/lib/api";
import { formatCrypto, formatDate, truncate } from "@/lib/format";

export default function AdminPayouts() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/payouts").then(({ data }) => setItems(data.payouts)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const update = async (id, status) => {
    try {
      const body = { status };
      if (status === "completed") body.tx_hash = "0x" + Math.random().toString(16).slice(2, 18);
      await api.patch(`/admin/payouts/${id}`, body);
      toast.success("Para çekme güncellendi.");
      load();
    } catch (e) { toast.error(apiErr(e)); }
  };

  if (!items) return <Spinner />;
  return (
    <div>
      <PageHeader title="Para Çekme Yönetimi" desc="Merchant para çekme taleplerini yönetin. Sağlayıcı desteklemiyorsa manuel işaretleyin." />
      {items.length === 0 ? <EmptyState title="Para çekme talebi yok" /> : (
        <Card className="overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="border-b border-border bg-muted/40"><tr className="text-left text-xs text-muted-foreground">
                {["Merchant", "Coin/Ağ", "Tutar", "Ücret", "Adres", "Hash", "Durum", "Tarih", "İşlem"].map((h) => <th key={h} className="px-4 py-3 font-medium whitespace-nowrap">{h}</th>)}
              </tr></thead>
              <tbody className="divide-y divide-border" data-testid="admin-payouts-table">
                {items.map((p) => (
                  <tr key={p.id} className="hover:bg-muted/30">
                    <td className="px-4 py-3 text-xs text-muted-foreground">{p.merchant_email}</td>
                    <td className="px-4 py-3"><span className="inline-flex items-center gap-1.5"><CoinIcon symbol={p.coin} size={16} /> {p.coin}·{p.network}</span></td>
                    <td className="px-4 py-3 font-semibold">{formatCrypto(p.amount, p.coin)}</td>
                    <td className="px-4 py-3 text-xs">{formatCrypto(p.fee, p.coin)}</td>
                    <td className="px-4 py-3 font-mono text-xs">{truncate(p.address, 8)}</td>
                    <td className="px-4 py-3 font-mono text-xs">{truncate(p.tx_hash || "-", 6)}</td>
                    <td className="px-4 py-3"><StatusBadge status={p.status} kind="payout" /></td>
                    <td className="px-4 py-3 text-xs text-muted-foreground whitespace-nowrap">{formatDate(p.created_at)}</td>
                    <td className="px-4 py-3">
                      {["pending", "processing"].includes(p.status) && (
                        <div className="flex gap-1">
                          <Button size="sm" variant="outline" className="rounded-full" onClick={() => update(p.id, "completed")}>Tamamla</Button>
                          <Button size="sm" variant="outline" className="rounded-full text-red-500" onClick={() => update(p.id, "failed")}>Reddet</Button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
